import { render } from "./index.vue?vue&type=template&id=42b20070&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=42b20070&lang=scss&scoped=true"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b20070"]])

export default __exports__